import { render, staticRenderFns } from "./ComponentLabel.vue?vue&type=template&id=2896e468&scoped=true&"
import script from "./ComponentLabel.vue?vue&type=script&lang=js&"
export * from "./ComponentLabel.vue?vue&type=script&lang=js&"
import style0 from "./ComponentLabel.vue?vue&type=style&index=0&id=2896e468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2896e468",
  null
  
)

export default component.exports